<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">贷款顾问</span>
    </navbar>
    <div class="loantype" :class="{noTop: isWechat}" v-show="typeList.length > 0">
      <typebar @click-handler="clickHandler" :type-list="typeList" :select-type-index="selectTypeIndex"
               :active-color="'#fffefe'" :color="'#dae4ee'"></typebar>
    </div>
    <div class="page-content" ref="pageContent" :class="{contentTop: !isWechat}" :style="{top: typeList.length > 0 ? '0.88rem' :'0rem'}">
      <scroller ref="scroller" :on-infinite="loadMore">
        <ul class="consultant-wrapper">
          <router-link tag="li" :to="`/consultant/articlelist/${item.uid}`" class="list-item clearfix" v-for="(item, index) in counselorList" :key="index">
            <div class="consultant-head">
              <img :src="item.logoUrl" alt="">
            </div>
            <div class="consultant-desc">
              <h3><span class="consultant-name">{{item.name}}</span><span class="consultant-job">{{item.profession}}</span></h3>
              <p class="skilled">{{[].concat(item.skills).join(' | ')}}</p>
              <div class="line"></div>
              <div class="consult-contact">
                <div class="contact-item"><span class="iconfont">&#xe614;</span><span class="phone">{{item.phone}}</span></div>
                <div class="contact-item"><span class="iconfont">&#xe615;</span><span class="wechat">{{item.wechat}}</span></div>
                <div class="contact-item" style="margin-top: 1px"><span class="iconfont">&#xe616;</span><span class="qq">{{item.qq}}</span></div>
              </div>
            </div>
          </router-link>
        </ul>
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from '../navbar/navbar'
  import Scroller from '../scroller/scroller'
  import Typebar from '../navbar/typebar'
  export default {
    data () {
      return {
        typeList: [],
        counselorList: [],
        pageSize: 5,
        pageNumber: 0,
        loanType: null,
        selectTypeIndex: null,
        hasmore: true,
        isWechat: false
      }
    },
    components: {
      Navbar,
      Scroller,
      Typebar
    },
    // 换城市更新贷款类型和贷款顾问
    watch: {
      loanType () {
        this.$refs.scroller.loadingState = 0
        this.$refs.scroller.scrollTo(0, 0)
        this.$refs.pageContent.style.height = '-1px'
        this.counselorList = [].splice(0, this.counselorList.length)
        this.$refs.scroller.resize()
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.scrollerContent = this.$refs.pageContent.getElementsByClassName('scroller-content')[0]
        setTimeout(() => {
          this.$refs.scroller.resize()
        }, 500)
      })
    },
    created () {
      this.getLoanTypeArr()
      if (this.$device.isWechat) {
        this.isWechat = true
      }
    },
    methods: {
      // 获取贷款类型
      getLoanTypeArr () {
        let vm = this
        this.$ajax({
          url: '/getLoanTypeMap.jhtml',
          params: {
            cityNo: this.$cache.getCity().code
          },
          done (result) {
            vm.typeList = [].concat(result)
          }
        })
      },
      // 获取贷款顾问
      _fetchCounserlorByLoanType () {
        let vm = this
        this.$ajax({
          url: '/getCounselorListForPage.jhtml',
          params: {
            cityNo: this.$cache.getCity().code,
            loanType: this.loanType,
            isPage: 'y',
            pageSize: this.pageSize,
            pageNumber: this.pageNumber || 1
          },
          done (list, page) {
            vm.pageNumber = page.pageNumber
            vm.hasmore = page.count > 0 && page.pageNumber * page.pageSize < page.count
            vm.counselorList = vm.counselorList.concat(list)
//            if (vm.hasmore) {
//              vm.$refs.scroller.finishInfinite(false)
//            } else {
//              vm.$refs.scroller.finishInfinite(true)
//            }
          },
          always () {
//            if (vm.scrollerContent) {
//              vm.scrollerContent.style.transform = 'translate3d(0, 0, 0)'
//              vm.$refs.scroller.resize()
//            }
            vm.$refs.scroller.finishInfinite(true)
          }
        })
      },
      // 获取擅长文本内容
     /* getSkillMap (skillScore) {
        let skill = []
        this.typeList.forEach(type => {
          if ((skillScore & type.code) === type.code) {
            skill.push(type.name)
          }
        })
        return skill
      }, */
      // 点击获取不同类型的顾问
      clickHandler (item, index) {
        /* if (this.selectTypeIndex == null && index != null) {
          this.selectTypeIndex = index
        } else {
          this.selectTypeIndex = index
        }
        this.counselorList = []
        item && (this.loanType = item.id)
        this._fetchCounserlorByLoanType() */
        this.hasmore = true
        this.pageNumber = 0
        this.loanType = item.id
        this.selectTypeIndex = index
      },
      // 滑动加载
      loadMore () {
        if (this.hasmore) {
          this.pageNumber++
          setTimeout(() => {
            this._fetchCounserlorByLoanType()
          }, 500)
        } else {
          this.$refs.scroller.finishInfinite(true)
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .navbar
    height px2rem(88)
    &.navbar-fixed
      & ~ .page-content
        top px2rem(180px)
        background-color rgba(255, 255, 255, 0.4)
  .loantype
    position absolute
    left 0
    right 0
    bottom 0
    top px2rem(88)
    height px2rem(88)
    line-height px2rem(88)
    background url("../../../static/images/bg-consultor.jpg") no-repeat left top
    background-size 100% auto
    color #dae4ee
    z-index 100
    .active
      color #fffefe
      font-weight bold
  .page-content
    .consultant-wrapper
      margin 0
      padding 0
      list-style none
      margin px2rem(31) px2rem(20) 0 px2rem(20)
      .list-item
        width px2rem(714)
        height  px2rem(272)
        margin-bottom px2rem(30)
        border-radius px2rem(10)
        padding px2rem(19) px2rem(19) px2rem(17) px2rem(23)
        background url("../../../static/images/bg-consultant.jpg") no-repeat top left
        background-size 100%
      .consultant-head
        float left
        width px2rem(188)
        height px2rem(238)
        img
          width px2rem(188)
          height px2rem(238)
          display block
      .consultant-desc
        width px2rem(458)
        float left
        margin-left px2rem(22)
        color #fff
        h3
          margin 0
          margin-bottom px2rem(19)
          span
            display inline-block
            margin 0
        .consultant-name
          max-width px2rem(160px)
          font-size px2rem(32px)
          padding-top px2rem(4)
          ellipsis()
        .consultant-job
          max-width px2rem(108px)
          margin-left px2rem(10px)
          font-size px2rem(24px)
          padding-top px2rem(4)
          ellipsis()
        .skilled
          width px2rem(458)
          font-size px2rem(24px)
          line-height px2rem(28px)
          height px2rem(110px)
          overflow hidden
          margin 0
        .line
          height 1px
          margin-top px2rem(18)
          background-color rgba(255,255,255,.3)
        .consult-contact
          width px2rem(458)
          margin-top px2rem(14px)
          height px2rem(30px)
          font-size px2rem(35px)
          line-height px2rem(30px)
          .contact-item
            width px2rem(152)
            float left
            font-family: DINCondBold,Arial;
            span
              display inline-block
              margin-right px2rem(15)
              line-height px2rem(35)
            .iconfont
              margin-right px2rem(10)
            .phone, .wechat, .qq
              font-size px2rem(20)
              line-height px2rem(20)
              max-width px2rem(90)
              ellipsis()
  .noTop
    top 0
  .contentTop
    margin-top px2rem(88)
</style>



// WEBPACK FOOTER //
// consultant.vue?643546c7